
 /* Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

fetch('/cart.js')
  .then(response => response.json())
  .then(data => {
    data.items.forEach(item => {
      if (item.price < 1) {
        var updates = {
          [item.id]: 0
        };

        fetch(window.Shopify.routes.root + 'cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ updates })
        })
        .then(response => {
          //alert();
          return response.json();
        })
        .catch(error => {
          console.error('Error:', error);
        });
      }
    });
  })
  .catch(error => {
    console.error('Error:', error);
  });

setTimeout(function () {
 $("body").on("click", "span.showwmore", function(){
   $(this).addClass("activeclass");
   $(this).parent().find('.showwless').removeClass("lactiveclass");
 });
  $("body").on("click", "span.showwless", function(){
   $(this).parent().find('.showwmore').removeClass("activeclass");
    $(this).addClass("lactiveclass");
 });
  $(".yottie-widget-contents").next().remove();
  //jQuery(".Collapsible__Button").trigger('click');
  $(".Product__Tabs .Rte p span").each(function(){
	var content = jQuery(this).html();
	if(jQuery.trim(content) == ""){
		jQuery(this).parent().remove();
	}
});
  $("body").on("click", "h3.descriptionexpandablelel", function(){
   $(this).toggleClass("opendesc");
 });
 $("body").on("change", "select#SortBy", function(){console.log($(this).find('option:selected').val());
    var vlk = $(this).val();
   $('button.Popover__Value.Heading.Link[data-value="'+vlk+'"]').trigger("click");
 });
$("body").on("click", ".Collapsible--large .Collapsible__Button", function(){
   $('.Collapsible.Collapsible--large.toggl_h').toggleClass("openClass");
 });
 
  $('button.CollectionToolbar__Item.CollectionToolbar__Item--sort.Heading.Text--subdued.u-h6.hide').html($('select#SortBy').val()+`<svg class="Icon Icon--select-arrow " role="presentation" viewBox="0 0 19 12">
      <polyline fill="none" stroke="currentColor" points="17 2 9.5 10 2 2" fill-rule="evenodd" stroke-width="2" stroke-linecap="square"></polyline>
    </svg>`);
                 }, 3000);
  $('button.CollectionToolbar__Item.CollectionToolbar__Item--sort.Heading.Text--subdued.u-h6.hide').html($('select#SortBy').val()+`<svg class="Icon Icon--select-arrow " role="presentation" viewBox="0 0 19 12">
      <polyline fill="none" stroke="currentColor" points="17 2 9.5 10 2 2" fill-rule="evenodd" stroke-width="2" stroke-linecap="square"></polyline>
    </svg>`);
 $("body").on("click", "button.Popover__Value", function(){
   $('button.CollectionToolbar__Item.CollectionToolbar__Item--sort.Heading.Text--subdued.u-h6.hide').html($(this).text()+`<svg class="Icon Icon--select-arrow " role="presentation" viewBox="0 0 19 12">
      <polyline fill="none" stroke="currentColor" points="17 2 9.5 10 2 2" fill-rule="evenodd" stroke-width="2" stroke-linecap="square"></polyline>
    </svg>`);
 });


